var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.step === _vm.flowStates.PROCESSING
        ? _c(
            "b-badge",
            { staticClass: "mr-3", attrs: { variant: "light-warning" } },
            [_vm._v(" Procesando ")]
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.PROCESSING
        ? _c(
            "b-avatar",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Procesando",
                  expression: "'Procesando'"
                }
              ],
              attrs: { rounded: "", size: "28", variant: "light-warning" }
            },
            [_c("feather-icon", { attrs: { size: "18", icon: "LoaderIcon" } })],
            1
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.PENDING
        ? _c(
            "b-badge",
            { staticClass: "mr-3", attrs: { variant: "light-secondary" } },
            [_vm._v(" Pendiente ")]
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.PENDING
        ? _c(
            "b-avatar",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Pendiente",
                  expression: "'Pendiente'"
                }
              ],
              attrs: { rounded: "", size: "28", variant: "light-secondary" }
            },
            [
              _c("feather-icon", {
                attrs: { size: "18", icon: "AlertCircleIcon" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.APPROVED
        ? _c(
            "b-badge",
            { staticClass: "mr-3", attrs: { variant: "light-success" } },
            [_vm._v(" Aprobado ")]
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.APPROVED
        ? _c(
            "b-avatar",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Aprobado",
                  expression: "'Aprobado'"
                }
              ],
              attrs: { rounded: "", size: "28", variant: "light-success" }
            },
            [
              _c("feather-icon", {
                attrs: { size: "18", icon: "ThumbsUpIcon" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.REJECTED
        ? _c(
            "b-badge",
            { staticClass: "mr-3", attrs: { variant: "light-danger" } },
            [_vm._v(" Rechazado ")]
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.REJECTED
        ? _c(
            "b-avatar",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Rechazado",
                  expression: "'Rechazado'"
                }
              ],
              attrs: { rounded: "", size: "28", variant: "light-danger" }
            },
            [
              _c("feather-icon", {
                attrs: { size: "18", icon: "ThumbsDownIcon" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.FORWARDED
        ? _c(
            "b-badge",
            { staticClass: "mr-3", attrs: { variant: "light-info" } },
            [_vm._v(" Reenviado ")]
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.FORWARDED
        ? _c(
            "b-avatar",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Reenviado",
                  expression: "'Reenviado'"
                }
              ],
              attrs: { rounded: "", size: "28", variant: "light-info" }
            },
            [
              _c("feather-icon", { attrs: { size: "18", icon: "ShuffleIcon" } })
            ],
            1
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.RETURNED
        ? _c(
            "b-badge",
            { staticClass: "mr-3", attrs: { variant: "light-info" } },
            [_vm._v(" Devuelto ")]
          )
        : _vm._e(),
      _vm.step === _vm.flowStates.RETURNED
        ? _c(
            "b-avatar",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Devuelto",
                  expression: "'Devuelto'"
                }
              ],
              attrs: { rounded: "", size: "28", variant: "light-info" }
            },
            [
              _c("feather-icon", {
                attrs: { size: "18", icon: "CornerUpLeftIcon" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }